import "./ComponentViewer.css";
import { useEffect, useState } from "react";

const TankComponentImage = ({ path, label, view, onClick }) => {
  const [exists, setExists] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = path;
    img.onload = () => setExists(true);
    img.onerror = () => setExists(false);
  }, [path]);

  const viewLabels = {
    0: "- Front/Back",
    1: "- Left/Right Side",
    2: "",
  };

  if (!exists) return null;

  return (
    <div className="component-image">
      <p className="sectionSubTitleText">
        {label} {viewLabels[view]}
      </p>
      <img
        className="component-thumbnail"
        src={path}
        alt={`${label}${viewLabels[view]}`}
        onClick={onClick}
      />
    </div>
  );
};

export default TankComponentImage;
